/**
 * ColorIdentityFilterDropdown - Exact color identity filter built on FilterDropdown.
 *
 * Renders all 32 MTG color identities (colorless through 5-color) as a searchable
 * multi-select dropdown with mana-font color wheel icons, grouped by color count.
 * Searching "blue" or "U" finds all identities containing blue.
 */
import type { ReactElement } from 'react';

import FilterDropdown from '@/components/FilterDropdown/FilterDropdown';

import { COLOR_IDENTITY_GROUPS, COLOR_IDENTITY_OPTIONS } from './colorIdentityData';

export interface ColorIdentityFilterDropdownProps {
  selectedIdentities: string[];
  onToggle: (identity: string) => void;
  onClear: () => void;
  className?: string;
}

const TRIGGER_ICON = <i className="ms ms-ci ms-ci-5" style={{ fontSize: '14px' }} aria-hidden="true" />;

export default function ColorIdentityFilterDropdown({
  selectedIdentities,
  onToggle,
  onClear,
  className,
}: ColorIdentityFilterDropdownProps): ReactElement {
  return (
    <FilterDropdown
      triggerLabel="Identity"
      triggerIcon={TRIGGER_ICON}
      ariaLabel="Color identity filter"
      searchPlaceholder="Search identities..."
      groups={COLOR_IDENTITY_GROUPS}
      options={COLOR_IDENTITY_OPTIONS}
      selectedValues={selectedIdentities}
      onToggle={onToggle}
      onClear={onClear}
      className={className}
    />
  );
}
